import { render } from "./TaskHome.vue?vue&type=template&id=2f8f5747&scoped=true"
import script from "./TaskHome.vue?vue&type=script&lang=js"
export * from "./TaskHome.vue?vue&type=script&lang=js"

import "./TaskHome.vue?vue&type=style&index=0&id=2f8f5747&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8f5747"]])

export default __exports__